import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { withRouter, Redirect } from 'react-router-dom';
import Core from '../../../class/Core';
import InputMask from 'react-input-mask';
import moment from 'moment';
import 'moment/locale/pt-br';

//actions
import * as UserActions from '../../../actions/UserActions';
import * as ManagerStatusActions from '../../../actions/StatusManagerActions.js';
import * as RedirectActions from '../../../actions/RedirectActions';
import * as StatusActions from '../../../actions/StatusActions';

class PagamentoSegProprio extends React.Component{
    constructor(props){
        super(props);
        this.core = new Core();
        this.core.isAuth();
        //define locale moment
        moment.locale('pt-BR');
        this.state = {
            relatorio: [],
            renderModal: <div></div>,
            selecao: {},
            trabs: [],
            empresa: null,
            dt_vencimento: null,
            qtd_total: 0,
            vlr_total: 0,
            qtd_ativos: 0,
            qtd_ate12m: 0,
            qtd_apos12m: 0,
            qtd_semdireito: 0,
            qtd_opositor: 0,
            qtd_idademaxima: 0,
            auth: this.core.getAuth(),
            totais: <div></div>,       
            colunas: <div></div>        
        }

        this.getTableShow = this.getTableShow.bind(this);
        this.showFiles = this.showFiles.bind(this);
        this.showTrabs = this.showTrabs.bind(this);
        this.handlerSubmit = this.handlerSubmit.bind(this);
        this.renderInputPlano = this.renderInputPlano.bind(this);
    }

    componentWillMount(){
        this.props.action.showManager();
        this.props.action.redirectClear();

    }

    generateRangeDate(){
        let range = [];
        
        let now = moment().date(1);
        range.push(moment(now));
        
        for(let i = 0; i < 5; i++){
            let mes = now.month() -1;
            now.month(mes);
            
            let date = moment(now);
            range.push(date);
        }

        range = range.map((data, index) => {
            return <option key={index + 1} value={data.format("YYYY-MM-DD")}>
                {data.format("MMMM")}
            </option>
        });

        //adiciona index 0 frase de seleção
        range.splice(0,0, <option key={0} checked value="">Selecione um mês</option>)
        return range;
    }

    generateplanosSelect(){
        let user =  this.props.user;

        let opt = [];
        if(user.segmentos !== undefined){
            opt = user.segmentos.map((data, index) => {
                return <option key={index + 1} value={data.id}>
                    {data.nome}
                </option>
            });
        }
    
        //adiciona index 0 frase de seleção
        opt.splice(0,0, <option key={0} checked value="">Todos os Planos</option>);

        return opt;
    }

    handlerSubmit(event){
        event.preventDefault();
        let self = this;
        let planos = [];
        

        /*
        if(event.target.plano.value !== ""){
            planos.push(event.target.plano.value);
        }else{
            planos =  this.core.getPlanosCorretora();
        }

        let data = {
            planos: planos
        }
        */
                
       let data = {
        }

        data.planos                 = event.target.plano.value; 
        
        data.date_ini               = event.target.date_ini.value;
        data.date_fim               = event.target.date_fim.value;
        data.trabalhador_pesquisa   = event.target.trabalhador_pesquisa.value;
        data.empresa_pesquisa       = event.target.empresa_pesquisa.value;
        data.pesquisa_parcial       = 'sim';
        data.mesano_vecto           = event.target.mesano_vecto.value;


        this.props.action.loadingStatus();

        fetch(self.core.getUrl() + self.core.getVersionAPI() + "empresa/relatorios/lista-empresa-segproprio2", {
            headers: {
                'Accept': 'application/json, text/plain, */*',
                'Content-Type': 'application/json',
                'Authorization': self.core.formatAutorizationToken(self.core.getToken())
            },
            method: 'POST',
            body: JSON.stringify(data)
        })
        .then(res => self.core.responseConvert(res))
        .then((response) => {
            let vlr_pago = 0
            let ativos = 0
            let ate12m = 0
            let apos12m = 0
            let semdireito = 0
            let opositor = 0
            let idademaxima = 0
            response.content.map ((val, index) => {
                vlr_pago += parseFloat(val.vlr_pago)
                ativos += parseFloat(val.ativos)
                ate12m += parseFloat(val.ate12m)
                apos12m += parseFloat(val.apos12m)
                semdireito += parseFloat(val.semdireito)
                opositor += parseFloat(val.opositor)
                idademaxima += parseFloat(val.idademaxima)
            })

            self.setState({
                relatorio: response.content,
                qtd_total: response.content.length,
                vlr_total: vlr_pago,
                qtd_ativos: ativos,
                qtd_ate12m: ate12m,
                qtd_apos12m: apos12m,
                qtd_semdireito: semdireito,
                qtd_opositor: opositor,
                qtd_idademaxima: idademaxima
            });
            self.props.action.loadedStatus();
        })
        .catch((err) => {
            self.core.catchFecth(err)
            self.props.action.loadedStatus();
        });
    }

    showFiles(files, selecao){
        let self = this;
        let data =  files.map((data, index) => {
            
            //coreção para novos formatos vindo
            let path = data;
            if(typeof path !== 'string'){
                path = data.path;
            }
            
            return <div key={index} className="form-group box-btn">
                <a className="btn btn-success" href={self.core.getUrl() + self.core.getVersionAPI() + "empresa/relatorios/arquivo?arquivo=" + path+"&token="+self.core.getToken() } target="_blank">Documento {index + 1}</a>
            </div>
        });
        this.setState({
            renderModal: data,
            selecao: selecao
        });
    }
    showTrabs(id_empr_blto_impr, razao_social, vencimento, segvida){
        this.empresa = razao_social;
        this.dt_vencimento = vencimento;
        this.setState({
            trabs: []
        })
               
        let self = this;
        this.props.action.loadingStatus();
        
        fetch(self.core.getUrl() + self.core.getVersionAPI() + "empresa/relatorios/empresas-trabalhadores-boleto-pago?id_empr_blto=" + id_empr_blto_impr
        ,{method: 'GET'}
        )
        .then(res => self.core.responseConvert(res))
        .then((response) => {
            let trabsres = response.content.map((trab, index) => {
                    return <tr key={index} >
                        <td>{trab.cpf}</td>
                        <td>{trab.nome}</td>
                        <td>{trab.sexo}</td>
                        <td>{trab.nascimento}</td>
                        <td>{trab.admissao}</td>
                    </tr>
    
                });
                    
            self.setState({
                trabs: trabsres
            });
            self.props.action.loadedStatus();
        })
        .catch((err) => {
            self.core.catchFecth(err)
            self.props.action.loadedStatus();
        })
                            
    }

    getTableShow(){

        let showNumber = 0;
        if(this.state.auth.config.grupo.nome === "administrador") {
            return this.state.relatorio.map((data, index) => {
                let files = [];
                if(data.parametros.pmtr_impr.files !== undefined){
                    files = data.parametros.pmtr_impr.files;
                }
                
                return  <tr key={index} >
                    <td style={{}}>{data.id_empr_blto}</td>
                    <td style={{}}>{data.cnpj}</td>
                    <td style={{}}>{data.razao_social}</td>
                    <td style={{}}>{data.placa}</td>
                    <td style={{}}>{data.vencimento_original}</td>
                    <td style={{}}>{data.pagamento}</td>
                    <td style={{textAlign:"right"}}>R$ {parseFloat(data.vlr_pago).toFixed(2)}</td>
                    <td style={{}}>{data.nosso_numero}</td>
                    <td style={{}}>{data.ativos}</td>
                    <td style={{}}>{data.ate12m}</td>
                    <td style={{}}>{data.apos12m}</td>
                    <td style={{}}>{data.semdireito}</td>
                    <td style={{}}>{data.opositor}</td>
                    <td style={{}}>{data.idademaxima}</td>
                    <td style={{}}>
                        {data.tipo == 'Acordo' ?  <button className="btn btn-ghost" type="button">{data.tipo}</button>
                         : <button className="btn btn-info" onClick={event => this.showFiles(files, data)} data-toggle="modal" data-target="#exampleModal">Documentos {showNumber ? ` (${files?.length})` : ""}</button>
                        }
                        {data.adic_docs ? <button className="btn btn-warning" onClick={event => this.showFiles(data.adic_docs, data)} data-toggle="modal" data-target="#exampleModal">Doc. Extras. {showNumber ? ` (${data.adic_docs?.length})` : ""}</button> : ''}
                    </td>
                    <td style={{}}>
                        <button className="btn btn-success" onClick={event => this.showTrabs(data.id_empr_blto, data.razao_social, data.vencimento, false)} data-toggle="modal" data-target="#trabModal">Trabalhadores</button>
                    </td>
                </tr>
            });
        }
        else {
            return this.state.relatorio.map((data, index) => {
                let files = [];
                if(data.parametros.pmtr_impr.files !== undefined){
                    files = data.parametros.pmtr_impr.files;
                }
                return  <tr key={index} >
                    <td>{data.cnpj}</td>
                    <td>{data.razao_social}</td>
                    <td>{data.plano}</td>
                    <td>{data.vencimento}</td>
                    <td>{data.pagamento}</td>
                    <td>
                        {data.tipo == 'Acordo' ?  <button className="btn btn-ghost" type="button">{data.tipo}</button>
                         : <button className="btn btn-info" onClick={event => this.showFiles(files, data)} data-toggle="modal" data-target="#exampleModal">Documentos {showNumber ? ` (${files?.length})` : ""}</button>
                        }
                        {data.adic_docs ? <button className="btn btn-warning" onClick={event => this.showFiles(data.adic_docs, data)} data-toggle="modal" data-target="#exampleModal">Doc. Extras.  {showNumber ? ` (${data.adic_docs?.length})` : ""}</button> : ''}
                    </td>
                    <td>
                        <button className="btn btn-success" onClick={event => this.showTrabs(data.id_empr_blto, data.razao_social, data.vencimento, false)} data-toggle="modal" data-target="#trabModal">Trabalhadores</button>
                    </td>
                </tr>
            });    

        }
    }

    renderInputPlano(){
        if(this.props.user.nome == 'UNIMED'){
            return <div className="col-sm-3">
                <div className="form-group">
                    <select name="plano" id="plano" className="form-control">
                        <option value="223">223</option>
                    </select>
                </div>
            </div>
        }
        return <div className="col-sm-3">
            <div className="form-group">
                <InputMask name="plano" id="plano" placeholder="Plano" className="form-control" mask="999" />
            </div>
        </div>
    }
    
    render(){
        
        let tableContent;
        let segvida = <span> Seguro Próprio </span>;
        
        if(this.props.redirect.url){
            return <Redirect to={this.props.redirect.url} />;
        }
        if(this.state.auth.config.grupo.nome === "administrador") {
            if(this.state.relatorio.length){
                tableContent = this.getTableShow();
            }else{
                tableContent = <tr>
                    <td colSpan={16}>
                        <center>
                            <b>Selecione um período para exibição do conteúdo</b>
                        </center>
                    </td>
                </tr>
            }
        }
        else {
            if(this.state.relatorio.length){
                tableContent = this.getTableShow();
            }else{
                tableContent = <tr>
                    <td colSpan={7}>
                        <center>
                            <b>Selecione um período para exibição do conteúdo</b>
                        </center>
                    </td>
                </tr>
            }

        }

        if(this.state.auth.config.grupo.nome === "administrador") {
            this.state.totais = 
            <table className="table table-striped table-doc">
                <thead>
                    <tr>
                        <th>Totais</th>
                        <th>Qth Pagamentos</th>
                        <th>Valor Total Pago</th>
                        <th>Ativos</th>
                        <th>Ate12m</th>
                        <th>Apos12m</th>
                        <th>Sem Direito</th>
                        <th>Opositor</th>
                        <th>Idade Maxima</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td></td>
                        <td style={{textAlign:"right"}}>{this.state.qtd_total.toLocaleString('pr-br')}</td>
                        <td style={{textAlign:"right"}}>R$ {this.state.vlr_total.toFixed(2).toLocaleString('pr-br')}</td>
                        <td style={{textAlign:"right"}}>{this.state.qtd_ativos.toLocaleString('pt-br')}</td>
                        <td style={{textAlign:"right"}}>{this.state.qtd_ate12m.toLocaleString('pt-br')}</td>
                        <td style={{textAlign:"right"}}>{this.state.qtd_apos12m.toLocaleString('pt-br')}</td>
                        <td style={{textAlign:"right"}}>{this.state.qtd_semdireito.toLocaleString('pt-br')}</td>
                        <td style={{textAlign:"right"}}>{this.state.qtd_opositor.toLocaleString('pt-br')}</td>
                        <td style={{textAlign:"right"}}>{this.state.qtd_idademaxima.toLocaleString('pt-br')}</td>
                    </tr>
                </tbody>
            </table>

            this.state.colunas = 
                <thead>
                    <tr>
                        <th>ID</th>
                        <th>CNPJ</th>
                        <th>Empresa</th>
                        <th>Plano</th>
                        <th>Vecto Original</th>
                        <th>Data Pagamento</th>
                        <th style={{textAlign:"right"}}>Vlr Pago</th>
                        <th>Nosso Numero</th>
                        <th>Ativos</th>
                        <th>-12m</th>
                        <th>+12m</th>
                        <th>Sem Direito</th>
                        <th>Opositor</th>
                        <th>Idade Maxima</th>
                        <th>Documentos</th>
                        <th>Trabalhadores</th>
                    </tr>
                </thead>


        } else {
            this.state.colunas = 
                <thead>
                    <tr>
                        <th>CNPJ</th>
                        <th>Empresa</th>
                        <th>Plano</th>
                        <th>Data Vencimento</th>
                        <th>Data Pagamento</th>
                        <th>Documentos</th>
                        <th>Trabalhadores</th>
                    </tr>
                </thead>
        }

        return <div className="page">
            <div className="page-content">
                <h2>Pagamentos de Empresas com Seguro Próprio</h2>
                <p>Consulte os documentos enviados e a relação de trabalhadores das empresas não optantes pelo Benefício Vida em Grupo</p>

                <div className="modal fade" id="exampleModal" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
                    <div className="modal-dialog" role="document">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title" id="exampleModalLabel">Documentos enviados - {this.state.selecao.razao_social}</h5>
                                <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <div className="modal-body">
                                {this.state.renderModal}
                            </div>
                            <div className="modal-footer">
                                <button type="button" className="btn btn-primary" data-dismiss="modal">FECHAR</button>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="modal fade" id="trabModal" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
                    <div className="modal-dialog modal-lg" role="document">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title" id="exampleModalLabel">Trabalhadores da Empresa {this.empresa}, Mes Ref: {this.dt_vencimento} - Com {segvida}</h5>
                                <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <div className="modal-body">
                            <table style={{width: 100 + '%'}}>
                                <thead>
                                    <tr>
                                        <th>CPF</th>
                                        <th>Nome</th>
                                        <th>Sexo</th>
                                        <th>Nascimento</th>
                                        <th>admissao</th>
                                    </tr>
                                </thead>  
                                <tbody>
                                    {this.state.trabs}
                                </tbody>
                            </table>
                            </div>
                            <div className="modal-footer">
                                <button type="button" className="btn btn-primary" data-dismiss="modal">FECHAR</button>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="panel">
                    <div  className='panel-title'>
                        <h3>
                            Selecione o plano e o período para a pesquisa
                        </h3>
                        <div  className="seleciona-mes-doc" >
                            <form onSubmit={this.handlerSubmit}>
                                <div className="row">
                                    {/*}
                                    <div className="col-sm-2">
                                        <select name="plano" id="plano" className="form-control">
                                            {this.generateplanosSelect()}
                                        </select>
                                    </div>
                                    */}
                                    {this.renderInputPlano()}
                                    <div className="col-sm-3">
                                        <div className="form-group">
                                            <InputMask name="date_ini" id="data_ini2" defaultValue={moment().startOf('month').format('DD/MM/YYYY')} placeholder="Data início" className="form-control" mask="99/99/9999" />
                                        </div>
                                    </div>
                                    <div className="col-sm-3">
                                        <div className="form-group">
                                            <InputMask name="date_fim" id="data_fim2" defaultValue={moment().endOf('month').format('DD/MM/YYYY')} placeholder="Data fim" className="form-control" mask="99/99/9999" />
                                        </div>
                                    </div>
                                    <div className="col-sm-3">
                                        <div className="form-group">
                                            <InputMask name="mesano_vecto" id="mesano_vecto" placeholder="Mês/Ano Vencimento" className="form-control" mask="99/9999" />
                                        </div>
                                    </div>
                                    <div className="col-sm-6">
                                        <div className="form-group">
                                            <input name="trabalhador_pesquisa" id="trabalhador_pesquisa" placeholder="Todos os Trabalhadores" className="form-control" />
                                        </div>
                                    </div>
                                    <div className="col-sm-6">
                                        <div className="form-group">
                                            <input name="empresa_pesquisa" id="empresa_pesquisa" placeholder="Todas as Empresas" className="form-control" />
                                        </div>
                                    </div>
                                    <div className="col-sm-12 text-right">
                                        <button type="Submit" className="btn btn-primary">pesquisar</button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>

                    <div className="panel-body container-fluid">
                        <div className="row" style={{maxWidth: '100% !important'}}>
                            {this.state.totais}
                        </div>

                        <div className="row" style={{maxWidth: '100% !important'}}>
                            <table className="table table-striped table-doc" style={{}}>
                                {this.state.colunas}

                                <tbody>
                                    {tableContent}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div> 


            </div>
        </div>
    }
}

function mapStateProps(state, props) {
    return {
        user: state.user,
        managerStatus: state.managerStatus,
        redirect: state.redirectReducer
    }
}

function mapDispatchProps(dispatch) {
    return {
        action: bindActionCreators({
            ...UserActions,
            ...ManagerStatusActions,
            ...RedirectActions,
            ...StatusActions
        }, dispatch)
    }
}
export default withRouter(connect(mapStateProps, mapDispatchProps)(PagamentoSegProprio))